<template>
  <div :class="$vuetify.breakpoint.name === 'lg' ? 'px-2' : 'px-5'">
    <Snackbar :snackbar="snackbar" :text="text" :timeout="timeout"></Snackbar>

    <!-- dialog riwayat pendaftaran -->
    <v-dialog v-model="dialog.riwayat_pendaftaran" scrollable max-width="1200">
      <v-card>
        <v-card-title
          class="background-first body-2 white--text py-1 pl-5 pr-2"
        >
          <span>Detail</span>
          <v-spacer />
          <v-btn
            color="#0299B7"
            small
            elevation="0"
            fab
            class="text-capitalize color-first"
            @click="dialog.riwayat_pendaftaran = false"
          >
            <v-icon small color="#FFFFFF">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-5">
          <v-row class="mt-0 mb-4" align="center" justify="space-between">
            <v-col cols="12" md="4" class="py-0">
              <div class="title">Riwayat pendaftaran</div>
            </v-col>
            <v-col cols="12" md="4" class="py-0">
              <v-text-field
                v-model="historySearch"
                outlined
                dense
                clearable
                hide-details
                placeholder="Cari . . ."
                prepend-inner-icon="mdi-magnify"
                color="#0299B7"
              />
            </v-col>
          </v-row>
          <div v-if="process.history" class="d-flex justify-center pa-8">
            <v-progress-circular indeterminate color="#0299B7" size="40" />
          </div>
          <v-data-table
            v-else
            :headers="historyHeaders"
            :items="historyRows"
            :search="historySearch"
            :items-per-page="10"
            class="elevation-1 required history-table pa-5"
          >
            <template v-slot:[`item.total_nilai_transaksi`]="{ item }">
              <span class="text-right d-block">{{
                item.total_nilai_transaksi
              }}</span>
            </template>
            <template v-slot:[`item.total_jasa_diterima`]="{ item }">
              <span class="text-right d-block">{{
                item.total_jasa_diterima
              }}</span>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <span :class="getStatusClass(item.status)">{{
                item.status
              }}</span>
            </template>
            <template v-slot:[`item.aksi`]="{ item }">
              <v-btn
                x-small
                fab
                icon
                color="#0299B7"
                @click="openRegistrationDetail(item)"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end dialog riwayat pendaftaran -->

    <!-- dialog pembayaran jasa -->
    <v-dialog
      v-model="dialog.pembayaran_jasa"
      scrollable
      persistent
      width="780"
    >
      <v-card>
        <v-card-title
          class="background-first body-2 white--text py-1 pl-5 pr-2"
        >
          <span>Pembayaran jasa</span>
          <v-spacer />
          <v-btn
            color="#0299B7"
            small
            elevation="0"
            fab
            class="text-capitalize color-first"
            @click="dialog.pembayaran_jasa = false"
          >
            <v-icon small color="#FFFFFF">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="color-first title font-weight-bold title mt-7 mb-2">
            Dari rekening
          </div>
          <v-row>
            <v-col cols="12" class="pt-0">
              <div class="background-blue">
                <div>
                  <div>
                    <span>Rekening <b>Bank Mandiri</b></span>
                  </div>
                  <div>
                    <span>No. rekening <b>137-00-0747021-0</b></span>
                  </div>
                  <div>
                    <span
                      ><b
                        >a.n Universitas Islam Indonesia - Lab Farmasi</b
                      ></span
                    >
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <div class="color-first title font-weight-bold title mt-7 mb-2">
            Rekening tujuan
          </div>
          <ValidationObserver ref="observer">
            <v-form>
              <v-row>
                <v-col cols="12" md="12" class="pb-0">
                  <ValidationProvider
                    name="No invoice"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      filled
                      disabled
                      readonly
                      type="text"
                      v-model="form.pembayaran_jasa.no_invoice"
                      label="No. invoice"
                      outlined
                      dense
                      color="#0299B7"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="12" class="pb-0 pt-0">
                  <ValidationProvider
                    name="Total jasa diterima"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      filled
                      disabled
                      readonly
                      type="text"
                      v-model="form.pembayaran_jasa.total_jasa_diterima"
                      label="Total jasa diterima (Rp)"
                      outlined
                      dense
                      color="#0299B7"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="12" class="pb-0 pt-0">
                  <ValidationProvider
                    name="Nomor rekening tujuan"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="form.pembayaran_jasa.nomor_rekening"
                      label="Nomor rekening tujuan"
                      type="number"
                      outlined
                      dense
                      color="#0299B7"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="12" class="pb-0 pt-0">
                  <ValidationProvider
                    name="Bank"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="form.pembayaran_jasa.bank"
                      label="Bank tujuan"
                      outlined
                      dense
                      color="#0299B7"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="12" class="pb-0 pt-0">
                  <ValidationProvider
                    name="Nama pemilik rekening"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="form.pembayaran_jasa.nama_pemilik_rekening"
                      label="Nama pemilik rekening"
                      outlined
                      dense
                      color="#0299B7"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="12" class="pb-0 pt-0">
                  <v-menu
                    ref="menunow"
                    v-model="form.pembayaran_jasa.item_now"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    class="z-my"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <ValidationProvider
                        name="Tanggal pembayaran"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="form.pembayaran_jasa.tanggal_bayar"
                          label="Tanggal pembayaran"
                          readonly
                          outlined
                          dense
                          color="#0299B7"
                          :error-messages="errors"
                          v-on="on"
                        >
                        </v-text-field>
                      </ValidationProvider>
                    </template>
                    <v-date-picker
                      v-model="form.pembayaran_jasa.tanggal_bayar"
                      v-on:change="changedate()"
                      color="#0299B7"
                      format="D MMMM YYYY"
                      @input="form.pembayaran_jasa.item_now = false"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="12" class="pb-0 pt-0">
                  <ValidationProvider
                    name="Bukti pembayaran"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-file-input
                      v-model="form.pembayaran_jasa.file"
                      label="Bukti pembayaran"
                      outlined
                      dense
                      color="#0299B7"
                      prepend-inner-icon="mdi-attachment"
                      accept=".jpg,.jpeg,.png,.pdf"
                      :rules="[fileSizeRule]"
                      :error-messages="errors"
                      max-size="500KB"
                    >
                    </v-file-input>
                    <i class="mt-1 caption color-second">
                      Maks 2MB dengan format file .pdf
                    </i>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="12" class="pb-0 pt-0">
                  <ValidationProvider name="Keterangan">
                    <v-text-field
                      v-model="form.pembayaran_jasa.keterangan"
                      label="Keterangan(Optional)"
                      outlined
                      dense
                      color="#0299B7"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-form>
          </ValidationObserver>
        </v-card-text>
        <v-divider
          style="border-color: #bac0c6; border-radius: 25px"
        ></v-divider>
        <v-card-actions class="mt-2 pb-3 justify-center">
          <v-btn
            outlined
            class="text-capitalize color-first mx-1"
            :disabled="process.form"
            @click="dialog.pembayaran_jasa = false"
          >
            Tutup
          </v-btn>
          <v-btn
            color="#0299B7"
            elevation="0"
            class="text-capitalize white--text mx-1"
            :disabled="process.form"
            @click="cekForm()"
          >
            Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog pembayaran jasa -->

    <!-- dialog ubah -->
    <v-dialog v-model="dialog.ubah" persistent width="650">
      <v-card>
        <v-card-title
          class="background-first body-2 white--text py-1 pl-5 pr-2"
        >
          <span>Ubah rekap jasa laboran</span>
          <v-spacer />
          <v-btn
            color="#0299B7"
            small
            elevation="0"
            fab
            class="text-capitalize color-first"
            @click="dialog.ubah = false"
          >
            <v-icon small color="#FFFFFF">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-5">
          <v-row>
            <v-col cols="12">
              <table
                width="100%"
                style="
                  font-family: Arial, Helvetica, sans-serif;
                  line-height: 1.7;
                  font-size: 14px;
                "
              >
                <tr>
                  <td width="35%">Nama</td>
                  <td width="3%">:</td>
                  <td>{{ edited.nama || "-" }}</td>
                </tr>
                <tr>
                  <td width="35%">Laboratorium</td>
                  <td width="3%">:</td>
                  <td>{{ edited.laboratorium || "-" }}</td>
                </tr>
                <tr>
                  <td width="35%">Jumlah kegiatan</td>
                  <td width="3%">:</td>
                  <td>{{ edited.jumlah_kegiatan || "-" }}</td>
                </tr>
                <tr>
                  <td width="35%">Masih berlangsung</td>
                  <td width="3%">:</td>
                  <td>{{ edited.masih_berlangsung || "-" }}</td>
                </tr>
                <tr>
                  <td width="35%">Total nilai transaksi (Rp)</td>
                  <td width="3%">:</td>
                  <td>{{ formatNumber(edited.total_nilai_transaksi) }}</td>
                </tr>
              </table>
            </v-col>
            <v-col cols="12" md="6" class="pb-0">
              <v-text-field
                dense
                outlined
                type="number"
                min="0"
                max="100"
                label="Pembagian jasa (%)"
                color="#0299B7"
                v-model="edited.pembagian_jasa"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pb-0">
              <v-text-field
                dense
                outlined
                label="No invoice"
                color="#0299B7"
                v-model="edited.no_invoice"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" class="pb-0">
              <v-select
                dense
                outlined
                :items="list.status_edit"
                item-text="nama"
                item-value="id"
                label="Status"
                color="#0299B7"
                v-model="edited.status"
              >
                <template v-slot:append>
                  <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" class="pt-0">
              <table
                width="100%"
                style="
                  font-family: Arial, Helvetica, sans-serif;
                  line-height: 1.7;
                  font-size: 14px;
                "
              >
                <tr>
                  <td width="35%">Total jasa diterima (Rp)</td>
                  <td width="3%">:</td>
                  <td>
                    <b>{{ totalJasaTerhitung }}</b>
                  </td>
                </tr>
              </table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider
          style="border-color: #bac0c6; border-radius: 25px"
        ></v-divider>
        <v-card-actions class="mt-2 pb-3 justify-center">
          <v-btn
            outlined
            class="text-capitalize color-first mx-1"
            :disabled="process.run"
            @click="dialog.ubah = false"
          >
            Tutup
          </v-btn>
          <v-btn
            color="#0299B7"
            elevation="0"
            class="text-capitalize white--text mx-1"
            :disabled="process.run"
            @click="
              save_type = 'ubah_rekap';
              dialog.konfirmasi = true;
            "
          >
            Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog ubah -->

    <!-- dialog konfirmasi -->
    <v-dialog v-model="dialog.konfirmasi" persistent width="450">
      <v-card>
        <v-card-title
          class="background-first body-2 white--text py-1 pl-5 pr-2"
        >
          <span>Konfirmasi</span>
          <v-spacer />
          <v-btn
            color="#0299B7"
            small
            elevation="0"
            fab
            class="text-capitalize color-first"
            @click="dialog.konfirmasi = false"
          >
            <v-icon small color="#FFFFFF">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-5 text-center mt-2">
          <span class="font-weight-bold title">
            Simpan data yang diinputkan ?
          </span>
          <v-card-subtitle class="pt-0">
            <span class="body-2">Pastikan data sudah sesuai</span>
          </v-card-subtitle>
        </v-card-text>
        <v-divider
          style="border-color: #bac0c6; border-radius: 25px"
        ></v-divider>
        <v-card-actions class="mt-2 pb-3 justify-center">
          <v-btn
            outlined
            class="text-capitalize color-first mx-1"
            :disabled="process.run"
            @click="dialog.konfirmasi = false"
          >
            Batal
          </v-btn>
          <v-btn
            color="#0299B7"
            elevation="0"
            class="text-capitalize white--text mx-1"
            :loading="process.run"
            :disabled="process.run"
            @click="save"
          >
            Ya, simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog konfirmasi -->

    <!-- dialog download -->
    <v-dialog v-model="dialog.download" scrollable persistent width="400">
      <v-card flat>
        <v-card-text class="text-center">
          <p class="mb-0 mt-3">Proses menyiapkan preview PDF....</p>
          <div class="mt-2">
            <v-progress-linear color="#0299B7" indeterminate rounded height="6">
            </v-progress-linear>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end dialog download -->

    <LoadingComponent v-if="process.loading"></LoadingComponent>

    <v-row
      class="mt-3"
      :class="$vuetify.breakpoint.name !== 'xs' ? 'px-3' : 'pr-0 pl-3'"
      v-if="!process.loading"
    >
      <v-col cols="12">
        <v-card class="border-radius box-shadow pa-1">
          <v-row>
            <v-col cols="12" class="py-0">
              <v-card-text>
                <div class="color-first title font-weight-bold title mt-3">
                  Pembagian fee lab
                </div>

                <!-- row filter -->
                <v-row class="pt-5">
                  <v-col cols="12" md="4">
                    <v-select
                      v-model="filter.period"
                      :items="list.period"
                      item-text="label"
                      item-value="value"
                      label="Periode pembayaran"
                      dense
                      outlined
                      color="#0299B7"
                      :disabled="process.run"
                      hide-details
                      @change="getList"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-select
                      v-model="filter.lab"
                      :items="list.lab"
                      item-text="nama_laboratorium"
                      item-value="id"
                      label="Laboratorium"
                      dense
                      outlined
                      color="#0299B7"
                      :disabled="process.run"
                      hide-details
                      @change="getList"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-select
                      v-model="filter.usage_type"
                      :items="list.usage_type"
                      item-text="jenis_penggunaan"
                      item-value="id"
                      label="Jenis pengguna"
                      dense
                      outlined
                      color="#0299B7"
                      :disabled="process.run"
                      hide-details
                      @change="getList"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select
                      v-model="filter.petugas"
                      :items="list.petugas"
                      item-text="nama"
                      item-value="id"
                      label="Petugas"
                      dense
                      outlined
                      color="#0299B7"
                      :disabled="process.run"
                      hide-details
                      @change="getList"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select
                      v-model="filter.status"
                      :items="list.status"
                      item-text="nama"
                      item-value="id"
                      label="Status"
                      dense
                      outlined
                      color="#0299B7"
                      :disabled="process.run"
                      hide-details
                      @change="getList"
                    />
                  </v-col>
                </v-row>
                <!-- end row filter -->

                <!-- infobox -->
                <v-row class="mt-5">
                  <v-col cols="12">
                    <div
                      class="pa-4 d-flex align-center"
                      style="background-color: #f2fafe; border-radius: 8px"
                    >
                      <v-icon color="#0077BB" class="mr-3"
                        >mdi-information</v-icon
                      >
                      <span class="body-2">
                        <b>Masih berlangsung</b> adalah kegiatan laboran
                        (penelitian, pengujian, dsb) sedang berlangsung, potensi
                        jasa (Rp) yang didapat belum bisa ditransfer karena
                        kegiatan belum selesai
                      </span>
                    </div>
                  </v-col>
                </v-row>
                <!-- end infobox -->

                <!-- row table -->
                <v-card-text
                  class="pa-5 px-0"
                  style="height: calc(100vh - 330px)"
                >
                  <v-skeleton-loader
                    :loading="process.run"
                    transition="scale-transition"
                    :tile="false"
                    :style="process.run ? 'height: calc(100vh - 400px)' : ''"
                    type="table-tbody"
                  >
                    <v-data-table
                      :headers="headers"
                      :items="rows"
                      :items-per-page="10"
                      class="elevation-1 required rekap-table"
                    >
                      <template v-slot:[`item.status`]="{ item }">
                        <td>
                          <span :class="getStatusClass(item.status)">{{
                            item.status
                          }}</span>
                        </td>
                      </template>
                      <template v-slot:[`item.aksi`]="{ item }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              x-small
                              fab
                              icon
                              min-width="30"
                              color="orange"
                              :disabled="process.run"
                              @click="detailForm(item)"
                              class="text-capitalize color-first pa-0 mx-1"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>Ubah</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              x-small
                              fab
                              icon
                              min-width="25"
                              color="#0299B7"
                              :disabled="process.run"
                              @click="printForm(item)"
                              class="text-capitalize color-first pa-0 mx-1"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <div
                                class="d-flex align-center text-capitalize body-2"
                              >
                                <img
                                  :src="
                                    require('@/assets/image/download_pdf.png')
                                  "
                                  alt=""
                                />
                              </div>
                            </v-btn>
                          </template>
                          <span>Print PDF</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              x-small
                              fab
                              icon
                              min-width="25"
                              color="#0299B7"
                              :disabled="process.run"
                              @click="openRiwayatPendaftaran(item)"
                              class="text-capitalize color-first pa-0 mx-1"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-eye</v-icon>
                            </v-btn>
                          </template>
                          <span>Riwayat pendaftaran</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-skeleton-loader>
                </v-card-text>
                <!-- end row table -->

                <!-- pdf -->
                <div>
                  <vue-html2pdf
                    :show-layout="false"
                    :float-layout="true"
                    :enable-download="false"
                    :preview-modal="true"
                    :paginate-elements-by-height="1400"
                    :filename="print_filename"
                    :pdf-quality="2"
                    :manual-pagination="false"
                    pdf-format="a4"
                    :pdf-margin="10"
                    pdf-orientation="portrait"
                    pdf-content-width="800px"
                    ref="html2Pdf"
                  >
                    <section slot="pdf-content">
                      <Pdf parameter="jasa-laboran" ref="pdf" v-model="files" />
                    </section>
                  </vue-html2pdf>
                </div>
                <!-- end pdf -->
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
const { VUE_APP_API_URL } = process.env;
import moment from "moment";
import "moment/locale/id";
import { get, put } from "@/service/Axios";
import { TokenService } from "@/service/Storage.Service";
import { serialize } from "object-to-formdata";
import statusMixin from "@/mixin";
import Snackbar from "@/components/Snackbar.vue";
import LoadingComponent from "@/components/Loading.vue";
import Pdf from "@/components/Pdf.vue";

// const endpoint = "laboran-fee-recap";
const endpoint = "research-recap";

export default {
  mixins: [statusMixin],
  data() {
    const periods = this.buildPeriods();
    return {
      dialog: {
        riwayat_pendaftaran: false,
        pembayaran_jasa: false,
        ubah: false,
        konfirmasi: false,
        download: false
      },
      detailUuid: "",
      detail: {},
      historySearch: "",
      historyRows: [],
      historyHeaders: [
        { text: "No.", value: "no", sortable: false },
        { text: "Jenis pengguna", value: "jenis_pengguna", sortable: false },
        { text: "Nama", value: "nama", sortable: false },
        {
          text: "Judul atau nama sampel",
          value: "judul_nama_sampel",
          sortable: false
        },
        {
          text: "Tanggal penggunaan",
          value: "tanggal_penggunaan",
          sortable: false
        },
        { text: "Status", value: "status", sortable: false },
        {
          text: "Total nilai transaksi (Rp)",
          value: "total_nilai_transaksi",
          align: "right",
          sortable: false
        },
        {
          text: "Pembagian jasa (%)",
          value: "pembagian_jasa",
          sortable: false
        },
        {
          text: "Total jasa diterima (Rp)",
          value: "total_jasa_diterima",
          align: "right",
          sortable: false
        },
        { text: "Aksi", value: "aksi", align: "center", sortable: false }
      ],
      edited: {},
      form: {
        pembayaran_jasa: {
          uuid: "",
          no_invoice: "",
          item_now: false,
          tanggal_bayar: "",
          total_jasa_diterima: "",
          nomor_rekening: "",
          bank: "",
          nama_pemilik_rekening: "",
          file: null,
          keterangan: ""
        }
      },
      fileSizeRule: (value) => {
        if (!value) {
          return true;
        }
        const size = value.size / 1024 / 1024; // konversi byte ke megabyte
        return size <= 500 ? true : "Ukuran file tidak boleh lebih dari 500KB";
      },
      filter: {
        period: periods[0] && periods[0].value,
        lab: "all",
        usage_type: "all",
        petugas: "all",
        status: "all"
      },
      process: {
        run: false,
        loading: false,
        history: false
      },
      list: {
        period: periods,
        lab: [],
        usage_type: [{ id: "all", jenis_penggunaan: "Semua" }],
        petugas: [
          { id: "all", nama: "Semua" },
          { id: "laboran", nama: "Laboran" },
          { id: "kalab", nama: "Kalab" }
        ],
        status: [
          { id: "all", nama: "Semua" },
          { id: "Belum bayar", nama: "Belum bayar" },
          { id: "Terbayar lunas", nama: "Terbayar lunas" }
        ],
        status_edit: [
          { id: "Belum bayar", nama: "Belum bayar" },
          { id: "Terbayar lunas", nama: "Terbayar lunas" }
        ]
      },
      rows: [],
      headers: [
        { text: "No.", value: "no", sortable: false },
        {
          text: "Jenis pengguna",
          value: "jenis_penggunaan",
          sortable: false
        },
        { text: "Nama", value: "nama", sortable: false },
        { text: "Petugas laboratorium", value: "petugas", sortable: false },
        { text: "Jumlah kegiatan", value: "jumlah_kegiatan", sortable: false },
        {
          text: "Masih berlangsung",
          value: "masih_berlangsung",
          sortable: false
        },
        {
          text: "Total nilai transaksi (Rp)",
          value: "total_nilai_transaksi",
          align: "right",
          sortable: false
        },
        {
          text: "Pembagian jasa (%)",
          value: "pembagian_jasa",
          sortable: false
        },
        {
          text: "Total jasa diterima (Rp)",
          value: "total_jasa_diterima",
          align: "right",
          sortable: false
        },
        { text: "No invoice", value: "no_invoice", sortable: false },
        { text: "Status", value: "status", sortable: false, width: "9%" },
        { text: "Aksi", value: "aksi", align: "center", width: "12%" }
      ],
      files: null,
      print_filename: "rekap-jasa-laboran",
      save_type: "",
      snackbar: false,
      text: "",
      timeout: 3000
    };
  },
  components: {
    Snackbar,
    LoadingComponent,
    Pdf
  },
  watch: {
    files: {
      handler: function () {
        this.dialog.download = this.files.add;
      },
      deep: true
    }
  },
  computed: {
    reminder() {
      let now = new Date(),
        next = new Date(now);
      next.setDate(now.getDate());
      return next.toISOString().substr(0, 10);
    },
    token() {
      return this.$store.state.access_token;
    },
    totalJasaTerhitung() {
      const nilai = Number(this.edited.total_nilai_transaksi) || 0;
      const persen = Number(this.edited.pembagian_jasa) || 0;
      return ((nilai * persen) / 100).toLocaleString("id-ID");
    }
  },
  mounted() {
    this.fetch();
  },
  methods: {
    buildPeriods() {
      const now = moment();
      const currentHalf = now.month() < 6 ? 0 : 1;
      const currentStart = moment([now.year(), currentHalf === 0 ? 0 : 6, 1]);
      return Array.from({ length: 10 }, (_, index) => {
        const start = currentStart.clone().subtract(index * 6, "months");
        const end = start.clone().add(5, "months").endOf("month");
        return {
          label: `${start.format("MMMM YYYY")} - ${end.format("MMMM YYYY")}`,
          value: `${start.format("YYYY-MM-DD")}|${end.format("YYYY-MM-DD")}`
        };
      });
    },
    async fetch() {
      this.process.loading = true;
      this.startLoading();
      await this.getLaboratory();
      await this.getUsageType();
      await this.getList();
      this.stopLoading();
    },

    async getLaboratory() {
      try {
        const params = { flag_lainnya: "1" };
        const { data, status } = await get("laboratory-master", { params });
        if (status === 200 && data.data) {
          const lab = data.data.map((item) => ({
            id: item.id,
            nama_laboratorium: item.namaLaboratorium
          }));
          lab.unshift({ id: "all", nama_laboratorium: "Semua" });
          this.list.lab = lab;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getUsageType() {
      try {
        const { data, status } = await get("usage-type");
        if (status === 200 && data.data) {
          const usageTypes = data.data.map((item) => ({
            id: item.id,
            jenis_penggunaan: item.jenisPenggunaan
          }));
          usageTypes.unshift({ id: "all", jenis_penggunaan: "Semua" });
          this.list.usage_type = usageTypes;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getList() {
      this.startLoading();
      try {
        const [startDate, endDate] = (this.filter.period || "").split("|");
        const params = {
          id_laboratorium: this.filter.lab,
          tgl_pembayaran_awal: startDate,
          tgl_pembayaran_akhir: endDate,
          status: this.filter.status
        };
        if (this.filter.usage_type !== "all") {
          params.id_jenis_penggunaan = this.filter.usage_type;
        }
        if (this.filter.petugas !== "all") {
          params.petugas = this.filter.petugas;
        }
        Object.keys(params).forEach((key) => {
          if (params[key] === "all" || !params[key]) delete params[key];
        });
        const { data, status } = await get(endpoint, { params });
        if (status === 200 && data.data) {
          this.rows = data.data.map((item, index) => this.mapRow(item, index));
        }
      } catch (error) {
        console.log(error);
        this.rows = [];
      } finally {
        this.stopLoading();
      }
    },

    async openRiwayatPendaftaran(item) {
      this.dialog.riwayat_pendaftaran = true;
      this.historySearch = "";
      this.process.history = true;
      this.historyRows = [
        {
          no: 1,
          jenis_penggunaan: item.jenis_penggunaan || "Penelitian",
          nama: item.nama || "Contoh Nama Pendaftar",
          judul_nama_sampel: "Contoh judul penelitian / nama sampel",
          tanggal_penggunaan: this.formatDate(new Date()),
          status: item.status || "Belum bayar",
          total_nilai_transaksi: item.total_nilai_transaksi || "1.000.000",
          pembagian_jasa: item.pembagian_jasa || "30",
          total_jasa_diterima: item.total_jasa_diterima || "300.000",
          uuid: item.uuid || "dummy-riwayat-1"
        },
        {
          no: 2,
          jenis_penggunaan: "Pengujian",
          nama: item.nama || "Contoh Nama Pendaftar",
          judul_nama_sampel: "Contoh nama sampel pengujian",
          tanggal_penggunaan: this.formatDate(new Date()),
          status: "Terbayar lunas",
          total_nilai_transaksi: "2.500.000",
          pembagian_jasa: "25",
          total_jasa_diterima: "625.000",
          uuid: "dummy-riwayat-2"
        }
      ];
      this.process.history = false;
    },

    openRegistrationDetail(item) {
      if (!item || !item.uuid) return;
      TokenService.setUuid(item.uuid);
      this.dialog.riwayat_pendaftaran = false;
      this.$router.push({ path: "/riwayat-laboran/detail" });
    },

    mapHistoryRow(record, index, parent) {
      return {
        no: index + 1,
        jenis_penggunaan:
          record.jenisPenggunaan ||
          record.jenisPengguna ||
          parent.jenis_penggunaan ||
          "-",
        nama: record.nama || parent.nama || "-",
        judul_nama_sampel:
          record.judul ||
          record.namaSampel ||
          record.namaBarang ||
          record.judulPenelitian ||
          "-",
        tanggal_penggunaan: this.formatDate(
          record.tglPenggunaan ||
            record.tglMulai ||
            record.tanggalPenggunaan ||
            record.penggunaanAwal
        ),
        status: record.status || record.statusPengajuan || parent.status || "-",
        total_nilai_transaksi: this.formatNumber(
          record.totalNilaiTransaksi !== undefined
            ? record.totalNilaiTransaksi
            : parent.total_nilai_transaksi_raw
        ),
        pembagian_jasa:
          record.pembagianJasa !== undefined
            ? record.pembagianJasa
            : parent.pembagian_jasa || "-",
        total_jasa_diterima: this.formatNumber(
          record.totalJasaDiterima !== undefined
            ? record.totalJasaDiterima
            : parent.raw && parent.raw.totalJasaDiterima
        ),
        uuid: record.uuid || ""
      };
    },

    mapRow(item, index) {
      return {
        no: index + 1,
        jenis_penggunaan: item.jenisPenggunaan || "-",
        nama: item.nama || "-",
        petugas:
          item.petugasLaboratorium || item.namaPetugas || item.petugas || "-",
        laboratorium: item.namaLaboratorium || "-",
        jumlah_kegiatan:
          item.jumlahKegiatan !== undefined ? item.jumlahKegiatan : "-",
        masih_berlangsung:
          item.masihBerlangsung !== undefined ? item.masihBerlangsung : "-",
        total_nilai_transaksi: this.formatNumber(item.totalNilaiTransaksi),
        pembagian_jasa:
          item.pembagianJasa !== undefined ? item.pembagianJasa : "-",
        total_jasa_diterima: this.formatNumber(item.totalJasaDiterima),
        no_invoice: item.noInvoice || "-",
        status: item.status || "-",
        total_nilai_transaksi_raw: item.totalNilaiTransaksi,
        raw: item
      };
    },

    editForm(item) {
      this.edited = {
        uuid: item.uuid || "",
        nama: item.nama,
        laboratorium: item.laboratorium,
        jenis_penggunaan: item.jenis_penggunaan,
        jumlah_kegiatan: item.jumlah_kegiatan,
        masih_berlangsung: item.masih_berlangsung,
        total_nilai_transaksi:
          Number(item.total_nilai_transaksi_raw) ||
          Number(String(item.total_nilai_transaksi || "").replace(/\./g, "")) ||
          0,
        pembagian_jasa: item.pembagian_jasa,
        no_invoice: item.no_invoice === "-" ? "" : item.no_invoice,
        status: item.status
      };
      this.dialog.ubah = true;
    },

    detailForm(item) {
      const { form } = this;
      this.detailUuid = item.uuid || "";
      form.pembayaran_jasa.uuid = item.uuid || "";
      form.pembayaran_jasa.no_invoice = item.no_invoice;
      form.pembayaran_jasa.total_jasa_diterima = item.total_jasa_diterima;
      form.pembayaran_jasa.nomor_rekening =
        item.raw && item.raw.noRekeningTujuan ? item.raw.noRekeningTujuan : "";
      form.pembayaran_jasa.bank =
        item.raw && item.raw.namaBankTujuan ? item.raw.namaBankTujuan : "";
      form.pembayaran_jasa.nama_pemilik_rekening =
        item.raw && item.raw.namaPemilikRekeningTujuan
          ? item.raw.namaPemilikRekeningTujuan
          : "";
      form.pembayaran_jasa.tanggal_bayar = "";
      form.pembayaran_jasa.file = null;
      form.pembayaran_jasa.keterangan = "";
      this.dialog.pembayaran_jasa = true;
    },

    printForm(item) {
      this.dialog.download = true;
      this.print_filename = `rekap-jasa-laboran-${(item.nama || "")
        .toLowerCase()
        .replace(/\s+/g, "-")}`;
      const payload = {
        jenisPenggunaan: item.jenis_penggunaan,
        nama: item.nama,
        namaLaboratorium: item.laboratorium,
        jumlahKegiatan: item.jumlah_kegiatan,
        masihBerlangsung: item.masih_berlangsung,
        totalNilaiTransaksi: Number(item.total_nilai_transaksi_raw) || 0,
        pembagianJasa: item.pembagian_jasa,
        totalJasaDiterima:
          Number(String(item.total_jasa_diterima || "").replace(/\./g, "")) ||
          0,
        noInvoice: item.no_invoice,
        status: item.status,
        periodeAwal: this.formatDate((this.filter.period || "").split("|")[0]),
        periodeAkhir: this.formatDate((this.filter.period || "").split("|")[1])
      };
      this.$store.dispatch("getDataPdf", payload);
      this.$refs.pdf.downloadPdf(item, this.$refs.html2Pdf);
    },

    async cekForm() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.save_type = "pembayaran_jasa";
        this.dialog.konfirmasi = true;
      }
    },

    async save() {
      switch (this.save_type) {
        case "pembayaran_jasa":
          this.savePembayaranJasa();
          break;
        case "ubah_rekap":
          this.saveUbah();
          break;
        default:
      }
    },

    async savePembayaranJasa() {
      this.process.form = true;
      const { token, form } = this;
      const value = {
        uuid: form.pembayaran_jasa.uuid,
        tgl_pembayaran: form.pembayaran_jasa.tanggal_bayar,
        no_rekening_tujuan: form.pembayaran_jasa.nomor_rekening,
        nama_bank_tujuan: form.pembayaran_jasa.bank,
        nama_pemilik_rekening_tujuan:
          form.pembayaran_jasa.nama_pemilik_rekening,
        file_bukti_pembayaran: form.pembayaran_jasa.file,
        keterangan: form.pembayaran_jasa.keterangan
      };

      const options = {
        indices: true,
        nullsAsUndefineds: false,
        booleansAsIntegers: false,
        allowEmptyArrays: false,
        noFilesWithArrayNotation: false,
        dotsForObjectNotation: false
      };

      const formData = serialize(value, options);

      const authHeader = new Headers({ Authorization: `Bearer ${token}` });

      const config = { method: "POST", headers: authHeader, body: formData };

      const response = await fetch(`${VUE_APP_API_URL}${endpoint}/pay`, config);
      if (response.status === 201) {
        this.dialog.konfirmasi = false;
        this.dialog.pembayaran_jasa = false;
        this.text = "Data pembayaran jasa laboran berhasil disimpan";
        this.snackbar = true;
        this.process.form = false;
        this.getList();
        this.$refs.observer.reset();
      } else {
        this.dialog.konfirmasi = false;
        this.process.form = false;
      }
    },

    async saveUbah() {
      try {
        this.process.run = true;
        const params = {
          uuid: this.edited.uuid,
          pembagian_jasa: this.edited.pembagian_jasa,
          no_invoice: this.edited.no_invoice,
          status: this.edited.status
        };
        const response = await put(endpoint, { params });
        if (response.status === 200) {
          this.dialog.konfirmasi = false;
          this.dialog.ubah = false;
          this.text = "Data rekap jasa laboran berhasil diupdate";
          this.snackbar = true;
          this.getList();
        } else {
          this.dialog.konfirmasi = false;
          this.dialog.ubah = false;
        }
      } catch (error) {
        console.log(error);
        this.dialog.konfirmasi = false;
        this.dialog.ubah = false;
      } finally {
        this.process.run = false;
      }
    },

    formatDate(value) {
      return value ? moment(value).locale("id").format("DD MMMM YYYY") : "-";
    },

    changedate() {
      this.form.pembayaran_jasa.tanggal_bayar = this.reminder;
    },

    formatNumber(value) {
      if (value === undefined || value === null || value === "") {
        return "-";
      }
      const number = Number(value);
      return Number.isNaN(number) ? value : number.toLocaleString("id-ID");
    }
  }
};
</script>

<style scoped>
.rekap-table {
  white-space: nowrap;
}

.rekap-table >>> th,
.rekap-table >>> td {
  white-space: nowrap;
}

.rekap-table >>> .v-data-table__wrapper {
  overflow-x: auto;
}
</style>
